module.exports = __webpack_public_path__ + "static/media/img-heritage-area1-Shoukasonjuku.9d03186e.jpg";